module.exports = __webpack_public_path__ + "static/img/s2.31299ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s2.png
// module id = lnR+
// module chunks = 1